import React from 'react';
import { withStyles, colors, Slider } from '@material-ui/core';

const styles = ({
    root: {
        color: colors.blue[600],
        width: '100%',
        height: 8,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -8,
        marginLeft: -12,
        '&:focus,&:hover,&$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    rail: {
        height: 8,
        borderRadius: 4,
    },
});

function CustomSlider (props){
    return <Slider
        {...props}
    />;
}

export default withStyles(styles)(CustomSlider);